import { IMAGES } from ".";

export default [
    IMAGES.partenaire1,
    IMAGES.partenaire2,
    IMAGES.partenaire3,
    IMAGES.partenaire4,
    IMAGES.partenaire5,
    IMAGES.partenaire6,
    IMAGES.partenaire7,
    IMAGES.partenaire8,
    IMAGES.partenaire9,
]